document.addEventListener("DOMContentLoaded", function (event) { // Wait until DOM is ready

    // Set vars and get elements

    const mainContiner = document.querySelectorAll('.discover-tgp');
    let playing;
    if (mainContiner) {
        mainContiner.forEach(container => {
            var maxVolume = 0.7;
            var duration;
            var filesLoaded = 0;
            var sounds = [];

            const transitionSpeed = 50; // Required to avoid audio pops when switching audio tracks.
            const vidElements = container.getElementsByClassName('demo-video');
            const videos = [];
            const video = container.querySelectorAll('.demo-video');
            video.forEach(vid => {
                videos.push(vid)
            })

            const playerConatainer = container.querySelector('.demo-player');
            const playButton = container.querySelector('.play');
            const pauseButton = container.querySelector('.pause');
            const resumeButton = container.querySelector('.resume');
            const volumeSlider = container.querySelector('.volume-slider');
            const timeline = container.querySelector('.timeline');
            const timelineMarker = container.querySelector('.timeline-marker');

            // Get total duration to set up timeline marker positioning
            container.querySelector('.vid1').addEventListener('durationchange', function () {
                duration = container.querySelector('.vid1').duration;
                timelineMarker.style.animationDuration = duration + 's';
            });

            // Get video files from ACF fields

            for (var i = 0; i < vidElements.length; i++) {
                if (i === 0) {
                    setVolume = '.7';
                } else {
                    setVolume = '0';
                }

                var sound = new Howl({
                    src: [vidElements.item(i).currentSrc],
                    volume: setVolume,
                    onload: function () {
                        filesLoaded++;
                        if (filesLoaded === 3) {
                            // Check if all files have been loaded
                            playerConatainer.classList.remove('inactive');
                        }
                    },
                    onplay: function () {
                        playButton.style.display = 'none';
                        resumeButton.style.display = 'none';
                        pauseButton.style.display = 'block';
                        playing = true;
                    },
                    onpause: function () {
                        resumeButton.style.display = 'none';
                        pauseButton.style.display = 'none';
                        playButton.style.display = 'block';
                        playing = false;
                    },
                    onend: function () {
                        resumeButton.style.display = 'none';
                        pauseButton.style.display = 'none';
                        playButton.style.display = 'block';
                        timelineMarker.style.clipPath = "inset(0 100% 0 0)";
                        playing = false;
                    },
                    onseek: function () { },
                });

                sounds.push(sound);
            }

            // Play button behaviour

            playButton.addEventListener('click', (event) => {
                // Start ADDITIONAL code //
                document.querySelectorAll('.active-video').forEach(function (target) {
                    target.classList.remove('active-video')
                });
                event.currentTarget.closest('.buttons').querySelector('#pause').classList.add('active-video');
                // End ADDITIONAL code //

                // if(playing) {
                //     document.querySelectorAll('.pause').forEach(function(target) {
                //         target.click();
                //     })
                //     document.querySelectorAll('.demo-video').forEach(function (target, index) {
                //         console.log('index========>', index);
                //         sounds[index].pause();
                //         target.pause();
                //     })
                // }

                sounds.forEach((sound) => {
                    sound.play();
                });
                videos.forEach((vid) => {
                    vid.play();
                });

                // Set interval to update timeline marker position 16ms to get 60fps movement

                setInterval(() => {
                    updateProgress();
                }, 16);

                // Animate timeline marker while playing

                function updateProgress() {
                    if (sounds[0].playing()) {
                        let currentPos = (sounds[0].seek() / sounds[0].duration()) * 100;
                        timelineMarker.style.clipPath = "inset(0 " + (100 - currentPos) + "% 0 0)";
                    }
                }

                // Start ADDITIONAL code //
                document.querySelectorAll('.pause').forEach(function (target) {
                    if (!target.classList.contains('active-video')) {
                        target.click();
                    }
                });
                // End ADDITIONAL code //

            });

            // Pause and resume functions
            function pauseAll() {
                sounds.forEach((sound) => {
                    sound.pause();
                });
                videos.forEach((vid) => {
                    vid.pause();
                });
            }

            function resumeAll(event) {
                // Start ADDITIONAL code //
                document.querySelectorAll('.active-video').forEach(function (target) {
                    target.classList.remove('active-video')
                });
                event.currentTarget.closest('.buttons').querySelector('#pause').classList.add('active-video');
                // End ADDITIONAL code //

                sounds.forEach((sound) => {
                    sound.play();
                });
                videos.forEach((vid) => {
                    vid.play();
                });

                // Start ADDITIONAL code //
                document.querySelectorAll('.pause').forEach(function (target) {
                    if (!target.classList.contains('active-video')) {
                        target.click();
                    }
                });
                // End ADDITIONAL code //
            }

            pauseButton.addEventListener('click', pauseAll, false);
            resumeButton.addEventListener('click', resumeAll, false);

            // Volume slider
            volumeSlider.addEventListener(
                'input',
                function () {
                    maxVolume = volumeSlider.value / 100;
                    sounds.forEach((sound) => {
                        if (sound.volume() != 0) {
                            // Don't change the volume of tracks that are meant to be muted
                            sound.volume(maxVolume);
                        }
                    });
                },
                false,
            );

            // Switch between audio and video tracks
            if (container.querySelectorAll('input[name="audio-toggle"]')) {
                container.querySelectorAll('input[name="audio-toggle"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }

            if (container.querySelectorAll('input[name="audio-toggle-1"]')) {
                container.querySelectorAll('input[name="audio-toggle-1"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }

            if (container.querySelectorAll('input[name="audio-toggle-2"]')) {
                container.querySelectorAll('input[name="audio-toggle-2"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }

            if (container.querySelectorAll('input[name="audio-toggle-3"]')) {
                container.querySelectorAll('input[name="audio-toggle-3"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }

            if (container.querySelectorAll('input[name="audio-toggle-4"]')) {
                container.querySelectorAll('input[name="audio-toggle-4"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }

            if (container.querySelectorAll('input[name="audio-toggle-5"]')) {
                container.querySelectorAll('input[name="audio-toggle-5"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }

            if (container.querySelectorAll('input[name="audio-toggle-6"]')) {
                container.querySelectorAll('input[name="audio-toggle-6"]').forEach((elem) => {
                    elem.addEventListener('change', function (event) {
                        var item = event.target.value;
                        sounds.forEach((sound) => {
                            sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
                        });

                        sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track

                        videos.forEach((vid) => {
                            vid.style.opacity = '0';
                        });
                        videos[item].style.opacity = '1';
                    });
                });
            }
            // Timeline scrubbing

            timeline.addEventListener('click', getClickPosition, false);

            function getClickPosition(e) {
                var xPercent = (e.offsetX / timeline.offsetWidth) * 100;
                var seekPosition = (xPercent / 100) * duration;
                timelineMarker.style.clipPath = "inset(0 " + (100 - xPercent) + "% 0 0)";

                sounds.forEach((sound) => {
                    sound.seek(seekPosition);
                });

                videos.forEach((vid) => {
                    vid.currentTime = seekPosition;
                });
            }
        })

    }

});
/*document.addEventListener("DOMContentLoaded", function (event) { // Wait until DOM is ready

  // Set vars and get elements

  const mainContiner = document.querySelectorAll('.discover-tgp');

  if(mainContiner) {
    mainContiner.forEach(container => {
    var maxVolume = 0.7;
    var duration;
    var filesLoaded = 0;
    var sounds = [];

    const transitionSpeed = 50; // Required to avoid audio pops when switching audio tracks.
    const vidElements = container.getElementsByClassName('demo-video');
    const videos = [];
    const video = container.querySelectorAll('.demo-video');
    video.forEach(vid => {
      videos.push(vid)
    })

    const playerConatainer = container.querySelector('.demo-player');
    const playButton = container.querySelector('.play');
    const pauseButton = container.querySelector('.pause');
    const resumeButton = container.querySelector('.resume');
    const volumeSlider = container.querySelector('.volume-slider');
    const timeline = container.querySelector('.timeline');
    const timelineMarker = container.querySelector('.timeline-marker');

    // Get total duration to set up timeline marker positioning
    container.querySelector('.vid1').addEventListener('durationchange', function () {
      duration = container.querySelector('.vid1').duration;
      timelineMarker.style.animationDuration = duration + 's';
    });

    // Get video files from ACF fields

    for (var i = 0; i < vidElements.length; i++) {
      if (i === 0) {
        setVolume = '.7';
      } else {
        setVolume = '0';
      }

      var sound = new Howl({
        src: [vidElements.item(i).currentSrc],
        volume: setVolume,
        onload: function () {
          filesLoaded++;
          if (filesLoaded === 3) {
            // Check if all files have been loaded
            playerConatainer.classList.remove('inactive');
          }
        },
        onplay: function () {
          playButton.style.display = 'none';
          resumeButton.style.display = 'none';
          pauseButton.style.display = 'block';
        },
        onpause: function () {
          pauseButton.style.display = 'none';
          resumeButton.style.display = 'block';
        },
        onend: function () {
          resumeButton.style.display = 'none';
          pauseButton.style.display = 'none';
          playButton.style.display = 'block';
          timelineMarker.style.clipPath = "inset(0 100% 0 0)";

        },
        onseek: function () { },
      });

      sounds.push(sound);
    }

    // Play button behaviour

    playButton.addEventListener('click', (event) => {
      // // Start ADDITIONAL code //
      // document.querySelectorAll('.active-video').forEach(function(target) {
      //   target.classList.remove('active-video')
      // });
      // event.currentTarget.closest('.buttons').querySelector('#pause').classList.add('active-video');
      // // End ADDITIONAL code //
      
      sounds.forEach((sound) => {
        sound.play();
      });
      videos.forEach((vid) => {
        vid.play();
      });

      // Set interval to update timeline marker position 16ms to get 60fps movement

      setInterval(() => {
        updateProgress();
      }, 16);

      // Animate timeline marker while playing

      function updateProgress() {
        if (sounds[0].playing()) {
          let currentPos = (sounds[0].seek() / sounds[0].duration()) * 100;
          timelineMarker.style.clipPath = "inset(0 " + (100 - currentPos) + "% 0 0)";
        }
      }

      // Start ADDITIONAL code //
      // document.querySelectorAll('.pause').forEach(function(target) {
      //   console.log(target.classList.contains('active-video'))
      //   if (!target.classList.contains('active-video')) {
      //     target.click();
      //   }
      // });
      // End ADDITIONAL code //

    });

    // Pause and resume functions
    function pauseAll() {
      sounds.forEach((sound) => {
        sound.pause();
      });
      videos.forEach((vid) => {
        vid.pause();
      });
    }

    function resumeAll() {
      sounds.forEach((sound) => {
        sound.play();
      });
      videos.forEach((vid) => {
        vid.play();
      });
    }

    pauseButton.addEventListener('click', pauseAll, false);
    resumeButton.addEventListener('click', resumeAll, false);

    // Volume slider
    volumeSlider.addEventListener(
      'input',
      function () {
        maxVolume = volumeSlider.value / 100;
        sounds.forEach((sound) => {
          if (sound.volume() != 0) {
            // Don't change the volume of tracks that are meant to be muted
            sound.volume(maxVolume);
          }
        });
      },
      false,
    );

    // Switch between audio and video tracks
    if(container.querySelectorAll('input[name="audio-toggle"]')) {
      container.querySelectorAll('input[name="audio-toggle"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }

      if(container.querySelectorAll('input[name="audio-toggle-1"]')) {
      container.querySelectorAll('input[name="audio-toggle-1"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }

      if(container.querySelectorAll('input[name="audio-toggle-2"]')) {
      container.querySelectorAll('input[name="audio-toggle-2"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }

      if(container.querySelectorAll('input[name="audio-toggle-3"]')) {
      container.querySelectorAll('input[name="audio-toggle-3"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }

      if(container.querySelectorAll('input[name="audio-toggle-4"]')) {
      container.querySelectorAll('input[name="audio-toggle-4"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }

      if(container.querySelectorAll('input[name="audio-toggle-5"]')) {
      container.querySelectorAll('input[name="audio-toggle-5"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }
      
      if(container.querySelectorAll('input[name="audio-toggle-6"]')) {
      container.querySelectorAll('input[name="audio-toggle-6"]').forEach((elem) => {
          elem.addEventListener('change', function (event) {
            var item = event.target.value;
            sounds.forEach((sound) => {
              sound.fade(sound.volume(), 0, transitionSpeed); // Fade out all audio tracks
            });
    
            sounds[item].fade(sounds[item].volume(), maxVolume, transitionSpeed); // Fade back in selected audio track
    
            videos.forEach((vid) => {
              vid.style.opacity = '0';
            });
            videos[item].style.opacity = '1';
          });
        });
    }
    // Timeline scrubbing

    timeline.addEventListener('click', getClickPosition, false);

    function getClickPosition(e) {
      var xPercent = (e.offsetX / timeline.offsetWidth) * 100;
      var seekPosition = (xPercent / 100) * duration;
      timelineMarker.style.clipPath = "inset(0 " + (100 - xPercent) + "% 0 0)";

      sounds.forEach((sound) => {
        sound.seek(seekPosition);
      });

      videos.forEach((vid) => {
        vid.currentTime = seekPosition;
      });
    }
  })

  }
  

});*/